import React from "react";
import * as styles from "./styles.module.css";
import Caret from "../../images/svg/caret.svg";
import { AccordeonProps } from "../interface/interface"

const Accordeon = React.forwardRef((props: AccordeonProps, ref: React.LegacyRef<HTMLDivElement>) => {

    const openAccordeon = () => {
        if (props.product && props.setIsOpened) {
            if(props.isOpened) {
                props.setIsOpened(-1);
            } else {
                props.setIsOpened(props.order);
            }
        } else if (props.setOpenAccordeon) {
            props.setOpenAccordeon(props.order);
        }
    }

    return props.product ? (
        <div className={`${styles.productcontainer} ${props.isOpened ? styles.productopened : ""}`}>
            <div ref={ref} onClick={openAccordeon} className={styles.productbuttoncontainer} >
                <p className={styles.productbuttontext}>{props.text}</p>
                <img src={Caret} alt="caret" className={props.isOpened ? styles.caretopened : styles.caret} />
            </div>
            <div className={styles.productcopy}>{props.children}</div>
        </div>
        ) : (
        <div className={`${styles.container} ${props.open? styles.open : ""}`} >
            <button onClick={openAccordeon} className={styles.button}>{props.buttontext && props.buttontext}</button>
            <div className={`${props.accordeonSize === 1 ? styles.copyhome : ""} ${props.accordeonSize === 2 ? styles.copyxponent : ""}`}>{props.text}</div>
        </div>
        )
});


export default Accordeon;


